<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Nova Transferência</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Transferir</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formTransferenciaBancaria" ref="formTransferenciaBancaria" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-autocomplete v-model="item.bancoOrigemId" :items="bancos" item-text="codigoNome" item-value="id" label="Banco de Origem" :rules="fieldRules" dense outlined/>
                            <!-- <v-select v-model="item.bancoOrigemId" label="Banco de Origem" :items="bancos" item-value="id" item-text="nome" dense outlined/> -->
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete v-model="item.bancoDestinoId" :items="bancos" item-text="codigoNome" item-value="id" label="Banco de Destino" :rules="fieldRules" dense outlined/>
                            <!-- <v-select v-model="item.bancoDestinoId" label="Banco de Destino" :items="bancos" item-value="id" item-text="nome" dense outlined/> -->
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.data" label="Data" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.data" no-title dense outlined/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field type="number" v-model.number="item.valor" label="Valor" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="9">
                            <v-text-field v-model="item.descricao" label="Descrição" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-switch v-model="item.identificada" label="Transferência Identificada" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>

import BancoService from '@/core/services/financeiro/BancoService';
import FluxoBancarioService from '@/core/services/financeiro/FluxoBancarioService';
import Transferencia from '@/core/domain/financeiro/Transferencia';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formTransferenciaBancaria' in this.$refs)
                this.$refs.formTransferenciaBancaria.resetValidation();
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        }
    },
    data: () => ({
        service: new FluxoBancarioService(),
        valid: true,
        dialog: false,
        isLoading: false,
        bancos: [],

        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        save() {

            if (this.$refs.formTransferenciaBancaria.validate()) {

                this.salvando = true;

                let modelo = new Transferencia(this.item);

                this.service.Transferir(modelo).then(
                    res => {
                        this.$swal('Aviso', res.data, res.status == 201 || res.status == 200 ? 'success' : 'warning');
                        this.$emit('salvou');
                        this.close();
                    }, 
                    err =>  {
                        this.$swal('Aviso', err.response.data.title ? err.response.data.title : err.response.data, err.response.status == 400 ? 'warning' : 'error');
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }
            
        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {

        let bancoService = new BancoService();
        bancoService.Listar()
            .then(
                res => {
                    const bancoDireto = res.data.items;

                    bancoDireto.forEach(x => {
                        if(x.situacao == 'A'){
                            this.bancos.push(x);
                        }
                    });
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

    }
}
</script>